// Pilot configuration.
//
// The passcode is a lightweight access gate for the closed beta — NOT real
// authentication. Set VITE_GAIT_PASSCODE at build time to override the default
// (see DEPLOY.md). Anyone with the code + URL can enter, so keep the URL private.

export const PILOT = {
  passcode: (import.meta.env.VITE_GAIT_PASSCODE as string | undefined) || "cadtomie",
  feedbackEmail: (import.meta.env.VITE_GAIT_FEEDBACK as string | undefined) || "feedback@cadtomie.com",
  /** Show the "evaluation / seed thresholds" badge while scores are uncalibrated. */
  evaluation: true,
  consentVersion: "v1",
  /**
   * Set VITE_GAIT_GATE_DISABLED=1 at build time (e.g. for an App Store
   * review / TestFlight build) to skip the closed-beta passcode screen.
   * The intended-use/consent acknowledgement still shows — App Review and
   * real users should still see it, it just isn't a secret gate. Default
   * off, so the ordinary pilot build behaves exactly as before.
   */
  gateDisabled: (import.meta.env.VITE_GAIT_GATE_DISABLED as string | undefined) === "1",
};

export const STORAGE_KEYS = {
  unlock: "gait.unlock.v1",
  consent: `gait.consent.${"v1"}`,
};
